(function() {
  'use strict';

  /**
   * Brands Grid - Alphabetical navigation for brands mega menu
   *
   * Original behavior: clicking a letter scrolls the brands grid
   * to the corresponding letter section inside the mega-menu.
   */

  // Prevent multiple global initializations of the helper
  if (window.BrandsGridInitialized) return;
  window.BrandsGridInitialized = true;

  class BrandsGrid {
    constructor(container) {
      this.container = container;
      this.letterButtons = container.querySelectorAll('.mega-menu__brands-letter-btn');
      this.init();
    }

    init() {
      this.letterButtons.forEach((button) => {
        button.addEventListener('click', (e) => this.handleLetterClick(e));
      });
    }

    handleLetterClick(e) {
      e.preventDefault();
      const button = e.currentTarget;
      const letter = button.dataset.letter;

      // Ignore disabled buttons
      if (button.disabled) return;

      // Update active state
      this.letterButtons.forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');

      // Scroll behavior
      if (letter === 'all') {
        // Scroll to top of brands grid container
        this.container.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      // Find the target section **within this specific grid container**
      // Avoid using document.getElementById because both desktop and mobile
      // grids share the same IDs, and that would always pick the first one.
      const targetSection =
        this.container.querySelector(`[data-brands-section="${letter}"]`) ||
        this.container.querySelector(`#brands-section-${letter}`);
      if (!targetSection) return;

      // Are we inside the mobile drawer?
      const inDrawer = !!this.container.closest('.menu-drawer__submenu');

      if (inDrawer) {
        // Mobile: let the browser handle scrolling within the drawer
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      } else {
        // Desktop: scroll inside the brands grid container itself
        const alphabetBar = this.container.querySelector('.mega-menu__brands-alphabet');
        const alphabetBarHeight =  130;
        
        const containerRect = this.container.getBoundingClientRect();
        const sectionRect = targetSection.getBoundingClientRect();
        const scrollOffset =
          sectionRect.top - containerRect.top + this.container.scrollTop;

        // Scroll within the container with offset for sticky alphabet nav
        this.container.scrollTo({
          top: scrollOffset - alphabetBarHeight,
          behavior: 'smooth',
        });
      }
    }
  }

  // Initialize all brands grids on page load
  document.addEventListener('DOMContentLoaded', () => {
    const brandsGrids = document.querySelectorAll('.mega-menu__brands-grid');
    brandsGrids.forEach((grid) => new BrandsGrid(grid));
  });

  // Re-initialize when mega menu content is dynamically loaded
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        if (node.classList?.contains('mega-menu__brands-grid')) {
          new BrandsGrid(node);
        }

        const brandsGrids = node.querySelectorAll?.('.mega-menu__brands-grid');
        brandsGrids?.forEach((grid) => new BrandsGrid(grid));
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();